export default __webpack_public_path__ + "static/media/MoreIcon_hover.d4508c88.svg";